import { ContactPageNumber, OptionsPageNumber, LandingPageNumber, CertificatePageNumber, ImageCapturePageNumber, ExteriorPageNumber, InteriorPageNumber, MechanicalPageNumber, VehiclePageNumber, LoadingPageNumber } from '../constants'
import { useDataLayerModules } from '../hooks/useDataLayerHooks'

let lastStep = -1

export default (landingContext, location) => {
  const { getQuestionResponse, globalState, updateGlobalState, urlState, plateStateVinError, vehicleIntoAuction } = landingContext
  const datalayerModules = useDataLayerModules(location, globalState, updateGlobalState)

  // waits for page fully mounted, analytics and data layer loaded
  if (!datalayerModules.getDataLayer) {
    return
  }

  const { getDataLayer, setDataLayer, appendLinkNameInDataLayer, addImpressionsToDataLayer, appendContactInfo, appendOfferInfo, addLinkNameToDataLayer } = datalayerModules
  // set landing page step for Condition page tabs

  let step = lastStep
  if (landingContext.experienceState.isAssigned) {
    // in case isAssigned, we should wait until fetch dealer group
    // is completed, (dealerGuid will be present after api call successed)
    if (landingContext.experienceState.dealerGuid) {
      step = urlState.p === ExteriorPageNumber ? globalState.np : urlState.p
    }
  } else {
    step = urlState.p === ExteriorPageNumber ? globalState.np : urlState.p
  }

  const dataLayer = getDataLayer(location)
  landingContext.addImpressions = addImpressionsToDataLayer

  if (dataLayer) {
    landingContext.visitorId = dataLayer.session.visitorId

    if ((landingContext.eligibility && landingContext.eligibility.isEligible === false || globalState.isIneligibleYear) && !globalState.fireAnalytics && !globalState.tagVmEligible) {
      updateGlobalState({ fireAnalytics: 'continue_timbuybkhome_selltrade' })
      updateGlobalState({ tagVmEligible: true })
    }
    if (globalState.fireAnalytics) {
      addLinkNameToDataLayer(globalState.fireAnalytics)

      // Steps that need additional data -- don't append for surveys though
      if (!globalState.fireAnalytics.startsWith('icoexit') && !globalState.fireAnalytics.startsWith('icosurvey')) {
        switch (step) {
          case LandingPageNumber:
            if (!globalState.componentFunnelAnalytics) {
              if (globalState.fireAnalytics.indexOf('continue') >= 0) {
                const analyticsTab = globalState.activeTab === 'License Plate' ? '_lp' : globalState.activeTab === 'VIN' ? '_vin' : globalState.activeTab === 'Make/Model' ? '_mm' : ''
                appendLinkNameInDataLayer(analyticsTab)
              }
              if (landingContext.eligibility && landingContext.eligibility.isEligible === false) {
                appendLinkNameInDataLayer('_ineligible_vm')
              }
              if (globalState.isIneligibleYear) {
                appendLinkNameInDataLayer('_ineligible_year')
              }
              if (landingContext.isVinError === true && !landingContext.vehicleIntoAuction) {
                appendLinkNameInDataLayer('_ineligible_invalid')
              }

              if (plateStateVinError) {
                const vinActiveDealer = landingContext.vinActiveDealer
                const isVinActiveDealer = !!vinActiveDealer && !!vinActiveDealer.totalResultCount && vinActiveDealer.totalResultCount > 0 && !vinActiveDealer.privateSeller && !landingContext.experienceState.isAdmin
                if (isVinActiveDealer) {
                  appendLinkNameInDataLayer('_ineligible_listedvin')
                }
                if (landingContext.autoCheckData) {
                  if (landingContext.autoCheckData.salvage === true) appendLinkNameInDataLayer('_ineligible_salvage')
                  if (landingContext.autoCheckData.floodDamage === true) appendLinkNameInDataLayer('_ineligible_flood')
                  if (landingContext.autoCheckData.frameDamage === true) appendLinkNameInDataLayer('_ineligible_frame')
                  if (landingContext.autoCheckData.notActualMileage === true) appendLinkNameInDataLayer('_ineligible_mileage')
                  if (landingContext.autoCheckData.auctionAnnouncementWithin45Days === true) appendLinkNameInDataLayer('_ineligible_auction')
                  if (landingContext.autoCheckData.previouslyCanadian === true) appendLinkNameInDataLayer('_ineligible_canadianreg')
                  if (landingContext.autoCheckData.liveryUse === true) appendLinkNameInDataLayer('_ineligible_liveryuse')
                  if (landingContext.autoCheckData.policeUse === true) appendLinkNameInDataLayer('_ineligible_policeuse')
                  if (landingContext.autoCheckData.taxiUse === true) appendLinkNameInDataLayer('_ineligible_taxiuse')
                  if (landingContext.autoCheckData.governmentUse === true) appendLinkNameInDataLayer('_ineligible_governmentuse')
                } else if (landingContext.vehicleIntoAuction) appendLinkNameInDataLayer('_ineligible_auctionapi')
                else if (!landingContext.isVinError) appendLinkNameInDataLayer('_error')
              }
            }
            break
          case ContactPageNumber:
            if (globalState.myKbbChecked) {
              appendLinkNameInDataLayer('_crtacct')
            }

            if (!globalState.isOfferCreationComponentEnabled && getQuestionResponse('qrv/LeadType').v && getQuestionResponse('qrv/LeadType').v === 'OptIn') {
              if (getQuestionResponse('qrv/LookingForNewCars').v === 0) {
                appendLinkNameInDataLayer('_tinew')
              }

              if (getQuestionResponse('qrv/LookingForCertifiedCars').v === 0) {
                appendLinkNameInDataLayer('_ticpo')
              }

              if (getQuestionResponse('qrv/LookingForUsedCars').v === 0) {
                appendLinkNameInDataLayer('_tiused')
              }
            }
            break
          case VehiclePageNumber:
            if (globalState.fireAnalytics.indexOf('continue_error') >= 0 && globalState.componentFunnelAnalytics === true) {
              appendLinkNameInDataLayer('_ineligible')
            }
            break
          case LoadingPageNumber:
            if (globalState.fireAnalytics === 'summary_submit_offer') {
              appendContactInfo(globalState)
            }
            break
          case CertificatePageNumber:
            appendOfferInfo(globalState)
            break
          default:
            break
        }
      }
      // set impressions trigger for Condition page
      let pageTrigger
      if (globalState.fireAnalytics === 'back') {
        pageTrigger = urlState.p === ExteriorPageNumber ? globalState.np : step
      } else {
        pageTrigger = step || urlState.p
      }
      setDataLayer({ landingContext, page: pageTrigger, event: 'Continue', location })
      globalState.fireAnalytics = undefined
    }

    if (lastStep !== step) {
      if (step !== OptionsPageNumber) {
        // force analytics for condition quiz tabs
        if (step === ExteriorPageNumber || step === InteriorPageNumber || step === MechanicalPageNumber) {
          let newPage = lastStep === (ImageCapturePageNumber || ContactPageNumber) ? ExteriorPageNumber : globalState.np
          globalState.np && setTimeout(() => setDataLayer({ landingContext, page: newPage, event: 'PageReady', location }), 150)
        } else if (step === undefined) {
          setTimeout(() => setDataLayer({ landingContext, page: urlState.p, event: 'PageReady', location }), 150)
        } else {
          const hasOfferInUrl = urlState?.pa && urlState.pa.length > 0 && urlState.pa.includes('offer')
          if (step === LandingPageNumber && hasOfferInUrl) {
            return
          }

          setTimeout(() => setDataLayer({ landingContext, page: step, event: 'PageReady', location }), 150)
        }
      }
    }

    lastStep = step
  }
}
